import { useCallback, Dispatch, SetStateAction } from 'react';
import { GameState } from '../../../domain/entities';

type SetGameState = Dispatch<SetStateAction<GameState | { gameStarted: false; }>>;

interface UseManagerManagementProps {
    setGameState: SetGameState;
}

export const useManagerManagement = ({ setGameState }: UseManagerManagementProps) => {
    const updateManagerName = useCallback((name: string) => {
        setGameState(prevState => {
            if (!prevState.gameStarted) return prevState;
            const newState: GameState = JSON.parse(JSON.stringify(prevState));
            (newState as any).gameStarted = true;
            newState.managerName = name;
            return newState;
        });
    }, [setGameState]);

    return {
        updateManagerName,
    };
};
